import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Store, Star } from 'lucide-react';
import { useTopBoutiques } from '../../hooks/useBoutiques';
import { PageStatus, SectionHeader } from '../UI';
import BoutiqueBadges from '../BoutiqueBadges/BoutiqueBadges';
import './TopBoutiques.css';

export default function TopBoutiques({ limit = 5 }) {
  const { t } = useTranslation('common');
  const { data, isLoading, error, refetch } = useTopBoutiques(limit);
  const boutiques = Array.isArray(data) ? data : [];
  const showEmpty = !isLoading && !error && boutiques.length === 0;

  return (
    <section className="top-boutiques-section">
      <div className="top-boutiques-container">
        <SectionHeader title={t('topPerformingBoutiques')}>
          {boutiques.length > 0 && (
            <Link to="/boutiques" className="view-all-btn">
              {t('viewAll')}
            </Link>
          )}
        </SectionHeader>

        <PageStatus
          isLoading={isLoading}
          loadingText={t('loading')}
          error={error}
          onRetry={() => refetch()}
          retryText={t('errors.tryAgain')}
          isEmpty={showEmpty}
          emptyIcon="store"
          emptyTitle={t('noBoutiquesYet')}
          emptyDescription={t('noBoutiquesYetDescription')}
          emptyActionText={t('empty.exploreShop')}
          emptyActionLink="/search"
          variant="inline"
        >
          <div className="top-boutiques-grid">
            {boutiques.map((b) => (
              <Link
                key={b.id}
                to={`/boutiques/${b.id}`}
                className="top-boutique-card"
              >
                <div className="top-boutique-logo">
                  {b.logo ? (
                    <img src={b.logo} alt={b.name} />
                  ) : (
                    <Store size={40} className="placeholder-icon" />
                  )}
                </div>
                <div className="top-boutique-info">
                  <h3 className="top-boutique-name">{b.name}</h3>
                  <BoutiqueBadges boutique={b} />
                  <div className="top-boutique-meta">
                    <span className="rating">
                      <Star size={14} fill="currentColor" />
                      {Number(b.rating ?? 0).toFixed(1)}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </PageStatus>
      </div>
    </section>
  );
}
